import { FC, useState, useMemo, useRef } from 'react'
import clsx from 'clsx'
import Image from 'next/image'

import useOnClickOutside from 'hooks/useClickOutside'
import { useAuth } from 'store/auth/useAuth'

import { FilterIconName, filterIconPath } from 'constants/search-data/search-data'
import { OptionIcons, Option } from 'components/webinar/webinar-with-format/data'
import { IObj } from 'constants/types/common.types'

import styles from './dropdown-list.module.scss'

interface IDropdownList {
  list: string[]
  selectedOption: string
  dropdownHandle?: (() => void) | undefined
  handleToggle?: (option: string) => void
  disabledOptions?: IObj<boolean> | null
}

const DropdownList: FC<IDropdownList> = ({
  list,
  dropdownHandle,
  selectedOption,
  handleToggle,
  disabledOptions,
}) => {
  const [isActive, setIsActive] = useState(false)
  const wrapperRef = useRef(null)

  const { isNotAuthorized } = useAuth()

  const handleClick = (e: any) => {
    e.preventDefault()
    dropdownHandle?.()
    setIsActive((prev) => !prev)
  }

  useOnClickOutside(isActive, wrapperRef, handleClick)

  const isDisableOption = (item: string) => {
    if (!disabledOptions?.withArticle && item === Option.read) {
      return true
    }
    if (!disabledOptions?.withAudio && item === Option.listen) {
      return true
    }
    if (!disabledOptions?.withMoments && item === Option.keyMoments) {
      return true
    }
    return false
  }

  return (
    <div
      className={clsx(styles.dropdownWrapper, {
        [styles.blocked]: isNotAuthorized,
      })}
      ref={wrapperRef}
    >
      <div className={styles.dropdownTextBlock} onClick={handleClick}>
        <Image {...OptionIcons[selectedOption]} className={styles.icon} />
        <p>{selectedOption}</p>
        <Image
          {...filterIconPath[FilterIconName.DROPDOWN]}
          className={clsx(styles.dropdownArrow, {
            [styles.dropdownArrowActive]: isActive,
          })}
        />
      </div>
      <div
        className={clsx(styles.dropdownListWrapper, {
          [styles.dropdownListWrapperActive]: isActive,
        })}
      >
        <div className={styles.dropdownList} onClick={handleClick}>
          {list.map((item) => (
            <div
              key={item}
              className={clsx(styles.dropdownItem, {
                [styles.dropdownItemActive]: selectedOption === item,
                [styles.optionDisabled]: isDisableOption(item),
              })}
              onClick={() => handleToggle && handleToggle(item)}
            >
              <Image {...OptionIcons[item]} className={styles.icon} />
              {item}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default DropdownList
